module.exports = __webpack_public_path__ + "static/media/26.2e2220a1.jpg";